export enum eDocumentVisibilityType {
  Client = 'CLIENT',
  Vendor = 'VENDOR',
}
